export default "__VITE_ASSET__u3Xf$f2a__"